export default {
  SET_HAS_CLAIM: 'SET_HAS_CLAIM',
  SET_ORG_ROLE: 'SET_ORG_ROLE',
};
